module.exports = __webpack_public_path__ + "img/sci4tech.1aea0750.jpg";